const { SingleSelectPrototype } = require("./prototypes");

function TextType() {
  this.type = "text";

  this.validate = ({ eligibility, answer }) =>
    new RegExp(eligibility).test(answer);
}

TextType.prototype = SingleSelectPrototype;

module.exports = TextType;
